export interface HistoryActors {
  userDisplayName?: string | null;
  actorDisplayName?: string | null;
}

export function withActorSuffix(
  message: string,
  actors?: HistoryActors,
): string {
  if (!actors?.actorDisplayName) return message;
  if (message.includes(actors.actorDisplayName)) return message;
  return `${message} · by ${actors.actorDisplayName}`;
}
